"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariantCompletionStatus = void 0;
const getOrderLineCompletionStatus_1 = require("./getOrderLineCompletionStatus");
const getVariantCompletionStatus = (variant) => {
    if (!variant)
        return 0;
    if (!variant.order_lines)
        return 0;
    return variant.order_lines.every((line) => (0, getOrderLineCompletionStatus_1.getOrderLineCompletionStatus)(line));
};
exports.getVariantCompletionStatus = getVariantCompletionStatus;
